import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

type BlobResponse = { data: Blob; headers: Record<string, any> };

async function getBlob(url: string): Promise<BlobResponse> {
  const response = await axios.get(url, { responseType: 'blob' });
  return { data: response.data as Blob, headers: response.headers as any };
}

/** GET /v1/gdpr/people/:id/export (admins): everything held about a person. */
export function exportPersonData(id: string) {
  return getBlob(`${API_HOST}/v1/gdpr/people/${encodeURIComponent(id)}/export`);
}

/** GET /v1/gdpr/me/export: everything held about the signed-in user. */
export function exportMyData() {
  return getBlob(`${API_HOST}/v1/gdpr/me/export`);
}

/**
 * POST /v1/gdpr/people/:id/erase (admins). The API checks `confirmEmail`
 * against the person's email and refuses to erase the last admin.
 */
export async function erasePersonData(id: string, confirmEmail: string) {
  const { data } = await axios.post(
    `${API_HOST}/v1/gdpr/people/${encodeURIComponent(id)}/erase`,
    { confirmEmail },
  );
  return data;
}
